module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"lock":"Interview by invitation only"}}')
  delete Component.options._Ctor
}
